import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class newsletterEmailPreview_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return (`
            <iframe
                class="w-iframe newsletter-email-preview"
                width="100%"
                style="border: 0; display: block; min-height: 50px;"
                title="Email preview"
                data-bind="attr: { srcdoc: html }, event: { load: onLoad }, visible: html() !== ''">
            </iframe>
        `);
    }

    protected buildViewModel(): any {
        return {
            html: ko.observable(""),
            onLoad: this.onLoad.bind(this),
        };
    }

    protected getTemplateName(): string {
        return "newsletterEmailPreview_template";
    }

    public setHtml(html: string): void {
        this.getTemplateViewModel().html(this.addPreviewFontFallback(html || ""));
    }

    /**
     * The final newsletter renderer wraps regular and Custom Content emails in
     * Helvetica/Arial. The admin preview receives only the stored content, so
     * provide the same fallback without changing what is saved or sent.
     */
    protected addPreviewFontFallback(html: string): string {
        const fallbackStyle = '<style>body { font-family: Helvetica, Arial, sans-serif; }</style>';
        const headTag = /<head(?:\s[^>]*)?>/i;

        if (headTag.test(html)) {
            return html.replace(headTag, (match) => match + fallbackStyle);
        }

        return fallbackStyle + html;
    }

    protected onLoad(data: any, event: Event): void {
        const iframe = event.target as HTMLIFrameElement;
        this.makeLinksOpenInNewTab(iframe);
        this.updateHeight(iframe);
        this.setupAutoResize(iframe);
    }

    protected makeLinksOpenInNewTab(iframe: HTMLIFrameElement): void {
        const document = iframe.contentDocument;
        if (!document) {
            return;
        }

        const openLinkInNewTab = (link: HTMLAnchorElement): void => {
            link.target = "_blank";
            const rel = (link.getAttribute("rel") || "").split(/\s+/);
            if (rel.indexOf("noopener") === -1) {
                rel.push("noopener");
                link.setAttribute("rel", rel.join(" ").trim());
            }
        };

        Array.prototype.forEach.call(document.querySelectorAll("a[href]"), openLinkInNewTab);
        document.addEventListener("click", (event: Event) => {
            let target = event.target as HTMLElement;
            while (target && target.tagName !== "A") {
                target = target.parentElement;
            }
            if (target && target.getAttribute("href")) {
                openLinkInNewTab(target as HTMLAnchorElement);
            }
        }, true);
    }

    protected updateHeight(iframe: HTMLIFrameElement): void {
        const document = iframe.contentDocument;
        if (!document) {
            return;
        }

        const body = document.body;
        const html = document.documentElement;
        const height = Math.max(
            body ? body.scrollHeight : 0,
            body ? body.offsetHeight : 0,
            body ? body.clientHeight : 0,
            html ? html.scrollHeight : 0,
            html ? html.offsetHeight : 0,
            html ? html.clientHeight : 0,
            50
        );
        iframe.style.height = height + "px";
    }

    protected setupAutoResize(iframe: HTMLIFrameElement): void {
        const document = iframe.contentDocument;
        if (!document) {
            return;
        }

        const existingObserver = (iframe as any).newsletterPreviewResizeObserver;
        if (existingObserver) {
            existingObserver.disconnect();
        }

        const ResizeObserverConstructor = (window as any).ResizeObserver;
        if (ResizeObserverConstructor) {
            const observer = new ResizeObserverConstructor(() => this.updateHeight(iframe));
            if (document.body) {
                observer.observe(document.body);
            }
            observer.observe(document.documentElement);
            (iframe as any).newsletterPreviewResizeObserver = observer;
        }

        [0, 100, 250, 500, 1000].forEach((delay) =>
            setTimeout(() => this.updateHeight(iframe), delay)
        );
        document.addEventListener("load", () => this.updateHeight(iframe), true);

        const fonts: any = (document as any).fonts;
        if (fonts && fonts.ready && typeof fonts.ready.then === "function") {
            fonts.ready.then(() => this.updateHeight(iframe));
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterEmailPreview_template.ts